import { classifyCoordinates } from '../geography/geozones';
import { normalizeCatalogCaza } from '../domain/tourismRules';

// Geographic membership is separate from editorial village/caza attribution.
// A Bsharri pin outside these Zgharta-only shapes is not an error.
export function withGeozones(items) {
  return items.map(item => {
    const geozone = classifyCoordinates(item.coordinates);
    if (normalizeCatalogCaza(item.caza) !== 'zgharta' && !geozone.zoneIds.length) return item;
    return { ...item, geozone };
  });
}
